import React, { useState } from "react"
import { Button } from "react-bootstrap"
import { api } from "../../core"
import * as FirebaseAuth from "firebase/auth"
import { useToast } from "popopo-lib-front/hook"

interface ChangeSpacePushSettingButtonProps {
  firebase: FirebaseAuth.User
  spaceKey: string;
  newAccept: boolean;
}

/**
 * スペースのプッシュ通知を無効化/有効化するボタンコンポーネント
 */
export const ChangeSpacePushSettingButton: React.FC<ChangeSpacePushSettingButtonProps> =
  ({
     firebase,
     spaceKey,
     newAccept
   }) => {
    const [isLoading, setIsLoading] = useState(false)
    const toast = useToast()

    // プッシュ通知設定を切り替える関数
    const togglePushNotification = async (accept: boolean) => {
      setIsLoading(true)

      try {
        const { data, error } = await api.PUT("/api/v2/users/me/user-space-setting/{space_key}", {
          params: {
            path: {
              space_key: spaceKey,
            },
          },
          body: {
            accept,
          },
          headers: {
            authorization: `Bearer ${await firebase.getIdToken()}`,
          },
        })

        if (data == null) {
          toast.add({
            type: "danger",
            title: "プッシュ通知設定の更新に失敗しました",
            message: JSON.stringify(error),
          })
        } else {
          toast.add({
            type: "success",
            title: "プッシュ通知設定を更新しました",
            message: `プッシュ通知を${accept ? "有効化" : "無効化"}しました`,
          })
        }

      } catch (err) {
        console.error(err)
        toast.add({
          type: "danger",
          title: "プッシュ通知設定の更新に失敗しました",
          message: err instanceof Error ? err.message : "不明なエラーが発生しました",
        })
      } finally {
        setIsLoading(false)
      }
    }

    return (
      <Button
        disabled={isLoading}
        onClick={() => togglePushNotification(newAccept)}
        variant={newAccept ? "primary" : "danger"}
      >
        {newAccept ? "プッシュ通知を有効化" : "プッシュ通知を無効化"}
      </Button>
    )
  }

export default ChangeSpacePushSettingButton
